const RuLokal = {
  draw: {
    toolbar: {
      actions: {
        title: 'Отменить рисование',
        text: 'Отмена'
      },
      finish: {
        title: 'Завершить рисование',
        text: 'Завершить'
      },
      undo: {
        title: 'Удалить последнюю нарисованную точку',
        text: 'Удалить последний'
      },
      buttons: {
        polyline: 'Рисовать множество линий',
        polygon: 'Рисовать многоугольник',
        rectangle: 'Рисовать прямоугольник',
        circle: 'Рисовать круг',
        marker: 'Рисовать маркер',
        circlemarker: 'Рисовать маркер-круг'
      }
    },
    handlers: {
      circle: {
        tooltip: {
          start: 'Для рисования круга кликните и перетащите'
        },
        radius: 'Радиус'
      },
      circlemarker: {
        tooltip: {
          start: 'Для размещения маркера-круга кликните на карте.'
        }
      },
      marker: {
        tooltip: {
          start: 'Для размещения маркера кликните на карте'
        }
      },
      polygon: {
        tooltip: {
          start: 'Для рисования фигуры кликните на карте',
          cont: 'Для продолжения рисования фигуры кликните',
          end: 'Кликните для завершения рисования'
        }
      },
      polyline: {
        error: '<strong>Ошибка:</strong> рёбра фигуры не могут пересекаться!',
        tooltip: {
          start: 'Для рисования линии кликните на карте',
          cont: 'Для продолжения рисования линии кликните',
          end: 'Кликните для завершения рисования линии'
        }
      },
      rectangle: {
        tooltip: {
          start: 'Для рисования прямоугольника кликните и перетащите'
        }
      },
      simpleshape: {
        tooltip: {
          end: 'Чтобы завершить рисование, отпустите мышь'
        }
      }
    }
  },
  edit: {
    toolbar: {
      actions: {
        save: {
          title: 'Сохранить изменения',
        text: 'Сохранить'
        },
        cancel: {
          title: 'Отменить редактирование, игнорируя предыдущие изменения',
          text: 'Отмена'
        },
        clearAll: {
          title: 'Удалить все слои',
          text: 'Удалить все'
        }
      },
      buttons: {
        edit: 'Редактировать слои',
        editDisabled: 'Нет слоев для редактирования',
        remove: 'Удалить слои',
        removeDisabled: 'Нет слоев для удаления'
      }
    },
    handlers: {
      edit: {
        tooltip: {
          text: 'Перетаскивайте маркеры или маркер для редактирования объекта.',
          subtext: 'Чтобы отменить изменения, нажмите кнопку "Отмена".'
        }
      },
      remove: {
        tooltip: {
          text: 'Чтобы удалить объект, кликните по нему.'
        }
      }
    }
  }
};

export default RuLokal